import { _request } from '@@/utils/request'
import CONFIG from '@@/config'

export const {
  HQPCB_HOST
} = CONFIG

export const pcbRequest = {
  get: (url, data, config = {}) => _request.get(`${HQPCB_HOST}${url}`, data, { ...config }),
  post: (url, data, config = {}) => _request.post(`${HQPCB_HOST}${url}`, data, { isFormData: true, ...config })
}

// PCB下单参数加/解密字段
const PCB_PARAMS_CRYPTO_KEYS = [
  'recevtel', 'orderman', 'ordertel', 'address', 'province_name', 'city_name', 'taxnumber', 'link_phone', 'link_name', 'idcard'
]

// 请求参数添加加密开关
const addCryptoSwitch = (data) => {
  if (data !== null && typeof data === 'object' && !Array.isArray(data)) {
    return Object.assign(data, { param_confused: 1 })
  }
  return data
}

// 解析PCB文件
export const fileAnalyzeResult = (data, key) => pcbRequest.post(`/ajax/fileAnalyzeResult${key || key === 0 ? '?key=' + key : ''}`, data)

// 解析3D文件
export const file3DAnalyzeResult = data => pcbRequest.post(`/ajax/file3DAnalyzeResult`, data)

// 获取叠层结构选项
export const getPressingOptions = data => pcbRequest.post('/public/getPressing', data)

// 获取PCB快递列表
export const getPcbExpress = data => pcbRequest.post('/Ucenter/PcbQuote/express', addCryptoSwitch(data), {
  reqCryptoKeys: PCB_PARAMS_CRYPTO_KEYS
})

// 获取账户余额
export const getBalance = () => pcbRequest.get('/Ucenter/Member/getBalance')

// PCB计价
export const getPcbPrice = data => pcbRequest.post('/Ucenter/PcbQuote/calc', addCryptoSwitch(data), {
  reqCryptoKeys: PCB_PARAMS_CRYPTO_KEYS
})

// 保存PCB计价信息
export const savePcbQuote = data => pcbRequest.post('/Ucenter/PcbQuote/save', addCryptoSwitch(data), {
  reqCryptoKeys: PCB_PARAMS_CRYPTO_KEYS,
  resultKey: 'result',
  resCryptoKeys: ['link_name', 'link_phone', 'idcard', 'taxnumber'].map(item => `data.${item}`)
})

// 获取PCB计价信息
export const getPcbQuote = params => pcbRequest.get('/Ucenter/PcbQuote/detail', params, {
  resultKey: 'result',
  resCryptoKeys: ['notify.link_name', 'notify.link_phone', 'notify.idcard', 'notify.taxnumber']
})

// 提交PCB订单
export const submitPcbQuote = data => pcbRequest.post('/Ucenter/PcbQuote/submit?ajax=1', addCryptoSwitch(data), {
  reqCryptoKeys: PCB_PARAMS_CRYPTO_KEYS
})

// 获取阶梯价格
export const getPriceList = data => pcbRequest.post('/quote/getBoardDiscountList', data)

// 获取PCB客户经理
export const getPcbService = () => pcbRequest.get('/ucenter/member/my_manager', {}, {
  resultKey: 'result',
  resCryptoKeys: ['name', 'nickname', 'qq', 'tel']
})

// 获取叠层结构计算列表
export const getPressingList = data => pcbRequest.post('/quote/recommendPressing', data, { isFormData: false })

// 获取板材列表
export const getBoardList = data => pcbRequest.post('/public/getBoardInfo', data)

// 获取设置的默认参数
export const getDefaultOption = () => pcbRequest.post('/Ucenter/Member/getDefaultOption')

// 设置默认参数
export const setDefaultOption = data => pcbRequest.post('/Ucenter/Member/setDefaultOption', data)

// 获取推荐拼版方式
export const getBoardSets = data => pcbRequest.post('/public/getBoardSets', data)

// 获取pcb/fpc返单详情
export const getPcbReDetail = data => pcbRequest.post(data.board_type == 'FPC' ? '/Ucenter/Reorder/fpcDetail' : '/Ucenter/Reorder/detail', data, {
  resultKey: 'result',
  resCryptoKeys: ['invoicetop', 'taxnumber', 'nickname', 'tel']
})

// 获取省市区
export const getRegionAll = () => pcbRequest.post('/public/getRegion')

// layout保存提交
export const layoutOrderSave = data => pcbRequest.post('/LayoutOrder/save', addCryptoSwitch(data), {
  reqCryptoKeys: ['order_user_name', 'ordertel', 'order_email']
})

// 钢网计价参数获取
export const getStencilParams = params => pcbRequest.get('/Ucenter/StencilQuote/params', params)

// 钢网计价
export const stencilValuation = data => pcbRequest.post('/Ucenter/StencilQuote/calc', addCryptoSwitch(data), {
  reqCryptoKeys: ['extaddress']
})

// 钢网计价提交暂存
export const stencilSave = data => pcbRequest.post('/Ucenter/StencilQuote/save', addCryptoSwitch(data), {
  reqCryptoKeys: ['extaddress']
})

// 钢网计价暂存查看
export const getStencilDetail = params => pcbRequest.get('/Ucenter/StencilQuote/detail', params, {
  resultKey: 'result',
  resCryptoKeys: [
    'quote.extaddress', 
    ...(['province_name', 'city_name', 'district_name', 'extaddress', 'address', 'idnum', 'orderman', 'ordertel', 'recevman', 'recevtel', 'telephone'].map(item => `address.default.${item}`)), 
    ...(['province_name', 'city_name', 'district_name', 'extaddress', 'address', 'idnum', 'orderman', 'ordertel', 'recevman', 'recevtel', 'telephone'].map(item => `address.list.${item}`)), 
    ...(['link_email', 'link_name', 'link_phone'].map(item => `notify.${item}`))
  ]
})

// 钢网提交
export const stencilSubmit = data => pcbRequest.post('/Ucenter/StencilQuote/submit', addCryptoSwitch(data), {
  reqCryptoKeys: ['enginer_name', 'enginer_phone', 'enginer_email', 'extaddress']
})

// 钢网快递参数
export const getStencilExpress = data => pcbRequest.post('/Ucenter/StencilQuote/express', addCryptoSwitch(data), {
  reqCryptoKeys: ['extaddress']
})

// 钢网关联订单查询
export const ajaxGetPcbOrder = data => pcbRequest.post('/Stencil/ajaxGetPcbOrder', data, {
  resultKey: 'result',
  resCryptoKeys: ['email', 'name', 'contact'].map(item => `engineer.${item}`)
})

// 获取自定义标签列表
export const getCustomTagsList = () => pcbRequest.post('/Ucenter/CustomTags/items')

// 删除自定义标签
export const deleteCustomTags = data => pcbRequest.post('/Ucenter/CustomTags/delete_tags', data)

// 设置默认自定义标签
export const setDefaultCustomTags = data => pcbRequest.post('/Ucenter/CustomTags/set_default', data)